import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators,FormGroupDirective} from '@angular/forms';
import { ApiService } from '../api.service';
import { ObservablesService } from '../observables.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Subject } from "rxjs";
import {Observable} from 'rxjs';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import {map, startWith} from 'rxjs/operators';
import { _ } from 'underscore';
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import {default as _rollupMoment} from 'moment';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-slip-form',
  templateUrl: './slip-form.component.html',
  styleUrls: ['./slip-form.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
 ],
})
export class SlipFormComponent implements OnInit, OnDestroy{
  // myControl = new FormControl('', Validators.required);
  parties:any = []
  options:any = []
  filteredOptions: Observable<string[]>;
  catOptions: Observable<any[]>[][] = [];
  itemOptions: Observable<string[]>[][] = [];
  // itemOptions: Observable<any[]>[] = [];

  // serializedDate = new FormControl((new Date()).toISOString());
  itemDetails:any=[];
  items:any=[];
  slipForm: FormGroup;
  // slip_date: string | number | Date;
  amount: any=0;
  totamt: number=0;
  gst_total_amt:number = 0;
  iterateSubscriber:any;
  iterationObserver:any = new Subject<any>();
  patchSubscriber:any;
  patchObserver:any = new Subject<any>();
  unitVariableIterateSubscriber:any;
  unitVariableIterationObserver:any = new Subject<any>();
  deleteUnitVariableIterateSubscriber:any;
  deleteUnitVariableIterationObserver:any = new Subject<any>();
  arrayUnitVariableIterateSubscriber:any;
  arrayUnitVariableIterationObserver:any = new Subject<any>();
  tagIterateSubscriber:any;
  tagIterationObserver:any = new Subject<any>();
  editIterateSubscriber:any;
  editIterationObserver:any = new Subject<any>();
  editProductIterateSubscriber:any;
  editProductIterationObserver:any = new Subject<any>();
  updateCategoryIterateSubscriber:any;
  updateCategoryIterationObserver:any = new Subject<any>();
  deleteCategoryIterateSubscriber:any;
  deleteCategoryIterationObserver:any = new Subject<any>();
  updateProductIterateSubscriber:any;
  updateProductIterationObserver:any = new Subject<any>();
  deleteProductIterateSubscriber:any;
  deleteProductIterationObserver:any = new Subject<any>();
  masterProductIterateSubscriber:any;
  masterProductIterationObserver:any = new Subject<any>();
  masterCategoryIterateSubscriber:any;
  masterCategoryIterationObserver:any = new Subject<any>();
  masterVariablesIterateSubscriber:any;
  masterVariablesIterationObserver:any = new Subject<any>();
  masterSlipProductsIterateSubscriber:any;
  masterSlipProductsIterationObserver:any = new Subject<any>();
  prepareProductsIterateSubscriber:any;
  prepareProductsIterationObserver:any = new Subject<any>();
  productSubscriber:any;
  editSlipSubscriber:any;
  editSlipInfo:any={editStatus:false,data:{direct_slip_status:0}};
  DeletedCategoryRows:any=[]
  DeletedProductRows:any=[]
  DeletedUnitVariableRows:any=[]
  editOnceStatus:boolean=false
  editStatus: boolean = false;
  existingSlipStatus: boolean = false;
  productObserver:any = new Subject<any>();
  editSlipId:any=''
  selectedParty:any=null;
  user_id:any;
  loggedUserInfo:any=[]
  units:any=[]
  business_id:any;
  parent_id:any;
  refreshTagsSubscriber:any;
  tags:any=[]
  editTags:any=[]
  party_gstin:any=null;
  productDetails:any=[];
  loadingStatus:boolean = false
  // arrayItems: {
  //    unit_variable_id: number;
  //    unit_variable: string;
  //  }[];
  constructor(private router:Router, private observables:ObservablesService,private formBuilder: FormBuilder, private api:ApiService, private datePipe: DatePipe) {
    // if(this.router.getCurrentNavigation().extras.state !== undefined){
    //   this.editSlipInfo = this.router.getCurrentNavigation().extras.state
    //   console.log("editSlipInfo=",this.editSlipInfo)
    // }

  }
  ngOnInit() {

    this.refreshTagsSubscriber = this.observables.refreshTagsStatus.subscribe(()=>{
      this.getTags();
    })

    if(this.editSlipInfo.data.direct_slip_status == 0){
      this.api.getLoggedUserInfo().then((res:any)=>{
        if(res.data.length > 0){
          this.loggedUserInfo = res.data[0];
          // console.log("loggedUserInfo=====",this.loggedUserInfo)
          if(this.loggedUserInfo.level == 1){
            this.business_id = this.loggedUserInfo.business_id
            this.user_id = this.loggedUserInfo.id
          }else if(this.loggedUserInfo.level > 1){
            this.user_id = this.loggedUserInfo.id
            this.parent_id = this.loggedUserInfo.parent_id
            this.business_id = this.loggedUserInfo.business_id
          }else{
            this.api.logOut()
          }

          this.getParty();
          this.getItem();

          if(this.loggedUserInfo.tag_subscribe_status){
            this.getTags();
          }

          this.getUnit();

          if(!this.editSlipInfo.editStatus) {
            this.getLastSlipId();

          }
        }

      })
      this.createForm()
    }

  }

  onTabChange(event){
    this.getLastSlipId()
  }

  getUnit(){
    this.api.send('findDb',{
      table:'units'
    }).then((res:any)=>{
      this.units = res.data;
    })
  }

  getItemUnit(unit_id){
    return this.units.filter(unit=>unit.id==unit_id)
  }

  getTag(tag_id){
    for(let i=0;i<this.tags.length;i++){
      if(this.tags[i].id == tag_id){
        return this.tags[i].tag_name
      }
    }
  }

  createForm(){

    if(!this.editSlipInfo.editStatus) {

      this.editStatus = false;
      this.editOnceStatus = false;
      this.slipForm = this.formBuilder.group({
        slip_number:[{value:''}, Validators.compose([Validators.required,Validators.pattern(/^[0-9]{1,6}$/)])],
        party_id:[null, Validators.required],
        user_id:[null],
        party_name:[null, Validators.required],
        slip_date:{value:moment(),disabled:true},
        payment_status:'unpaid',
        delivery_to:null,
        total_amount: [{value:this.totamt,disabled:true}, Validators.required],
        gst_total_amount:this.gst_total_amt,
        categories: this.formBuilder.array([this.categories]),
        tags:[null],
        note:[null]
      });

      this.manageCategoryControl(0,((this.slipForm.get("categories") as FormArray).at(0) as FormGroup),0)
      this.ManageNameControl(0,((this.slipForm.get("categories") as FormArray).at(0) as FormGroup),0)



    }else{
      if(!this.editOnceStatus && this.editSlipInfo.data.direct_slip_status == 0){
        this.editSlip()
      }
    }

  }


  editSlip(){
    if(this.editSlipInfo.editStatus){
      this.editOnceStatus = true;
      this.editStatus = true;
      this.DeletedCategoryRows=[];
      this.DeletedProductRows=[];
      this.editSlipId = this.editSlipInfo.data.id;
      // this.getMasterSlipData(this.editSlipId).then((resp:any)=>{
      //   console.log("response==",resp);
      //   if(resp.data.length > 0){
      //     this.masterSlipData = resp.data
      //     let groups = _.groupBy(resp.data,"category_id");
      //     console.log("master value==",_.values(groups));
      //
      //   }
      // })
      this.slipForm = this.formBuilder.group({
        slip_number:[{value:this.editSlipInfo.data.slip_number,disabled:true}, Validators.compose([Validators.required,Validators.pattern(/^[0-9]{1,6}$/)])],
        party_id:this.editSlipInfo.data.party_id,
        user_id:this.editSlipInfo.data.user_id,
        party_name:this.editSlipInfo.data.business_name,
        slip_date:{value:new Date(this.editSlipInfo.data.slip_date),disabled:true},
        payment_status:this.editSlipInfo.data.payment_status,
        delivery_to:this.editSlipInfo.data.delivery_to,
        total_amount: [{value:this.editSlipInfo.data.total_amount,disabled:true}, Validators.required],
        gst_total_amount:this.editSlipInfo.data.gst_total_amount,
        categories: this.formBuilder.array([this.categories]),
        tags:[null],
        note:this.editSlipInfo.data.note
      });

      this.editTags=[]
      this.api.send("findDb",{
        table:"slip_invoice_tags",
        conditions:[{slip_id:this.editSlipInfo.data.id}]
      }).then((res:any)=>{
        if(res.data.length > 0){
          for(let i=0;i<res.data.length;i++){
            this.editTags.push(res.data[i].tag_id)
            if(i==res.data.length -1){

              this.slipForm.patchValue({tags:this.editTags})
              // console.log("tags=",tags)
            }
          }

        }
      })

      this.api.send("findDb",{
        table:"categories",
        conditions:[{slip_id:this.editSlipInfo.data.id}]
      }).then((res:any)=>{
        if(res.data.length > 0){
          this.getCategories(res.data)
        }
      })
    }

  }



  getCategories(categories){
    let k=0;
    this.manageCategoryControl(0,((this.slipForm.get("categories") as FormArray).at(0) as FormGroup),0);
    this.editIterateSubscriber = this.editIterationObserver.subscribe((k)=>{
      if(k>=categories.length){
        this.editIterateSubscriber.unsubscribe()
      }else{
        (<FormArray>this.slipForm.controls['categories']).at(k).patchValue({'category_id':categories[k].id,'category_name':categories[k].category_name});
        this.api.send("findDb",{
          table:"product_details as P",
          fields:["P.*","I.name","I.gst","I.rate as item_rate","I.unit_id","I.cess"],
          joins:[{
            type:"left",
            table:"items as I",
            conditions:["I.id = P.item_id"]
          }],
          conditions:[{"P.category_id":categories[k].id,"P.slip_id":this.editSlipInfo.data.id}],
          order:"id ASC"
        }).then((res1:any)=>{
          if(res1.data.length > 0){
            this.getProducts(res1.data,k).then((status)=>{

              if(status){
                if(k+1 == categories.length){
                  this.editIterationObserver.next(k+1)
                }else{
                  this.addCategory().then(()=>{
                    this.editIterationObserver.next(k+1)
                  })

                }

              }
            })
          }
        })

      }
    })

    this.editIterationObserver.next(k)
  }

  getProducts(products,i){
    // console.log("products=",products)
    return new Promise((resolve)=>{
      let k=0;
      this.ManageNameControl(k,((this.slipForm.get("categories") as FormArray).at(i) as FormGroup),i);
      const controls = ((this.slipForm.get("categories") as FormArray).at(i).get("products") as FormArray);
      this.editProductIterateSubscriber = this.editProductIterationObserver.subscribe((k)=>{
        if(k>=products.length){
          this.editProductIterateSubscriber.unsubscribe()
          resolve(true);
        }else{

            controls.at(k).patchValue(
              {
                  product_id:products[k].id,
                  qty:products[k].qty,
                  description:products[k].description,
                  rate:products[k].rate,
                  amount:products[k].amount,
                  item:products[k].item_id,
                  item_name:products[k].name,
                  item_code:products[k].item_code,
                  gst:products[k].gst,
                  unit_id:products[k].unit_id,
                  discount:products[k].discount
              }

            )



            this.api.send("findDb",{
              fields:["P.*","U.*","P.id as product_unit_variable_id"],
              table:"product_unit_variables as P",
              joins:[{
                type:"left",
                table:'unit_variables as U',
                conditions:["U.id = P.unit_variable_id"]
              }],
              conditions:[{"P.product_detail_id":products[k].id}],
              order:"P.unit_variable_id ASC"
            }).then((res:any)=>{
              let item = this.items.filter(item=>item.id == products[k].item_id)
              // console.log("item=",item)
              this.manageVariableControl(controls.at(k),item[0])
              // console.log("res====",res.data)
              if(res.data.length > 0){
                this.patchValues(res.data,controls,k).then((patchRes:any)=>{
                  this.calculateTotal(k,i,((this.slipForm.get("categories") as FormArray).at(i) as FormGroup),controls.at(k));
                  if(k+1 == products.length){

                    this.editProductIterationObserver.next(k+1)
                  }else{
                    this.addProduct(((this.slipForm.get("categories") as FormArray).at(i) as FormGroup),i);
                    this.editProductIterationObserver.next(k+1)
                  }
                })


              }else{
                if(k+1 == products.length){

                  this.editProductIterationObserver.next(k+1)
                }else{
                  this.addProduct(((this.slipForm.get("categories") as FormArray).at(i) as FormGroup),i);
                  this.editProductIterationObserver.next(k+1)
                }
              }
            })

            // this.patchItemValue(products[k].item_id,controls,k)
          }

      })

      this.editProductIterationObserver.next(k)
    })
  }

  patchValues(data,controls,k){
    // console.log("data==",data)
    // console.log("controls==",controls)
    return new Promise((resolve)=>{
      let a = 0;

      this.patchSubscriber = this.patchObserver.subscribe((a:any)=>{
        if(a>=data.length){
          this.patchSubscriber.unsubscribe()
          resolve(true)
        }else{

          // console.log("form==",(controls.at(k).get('demoArray') as FormArray));
          // console.log("value=",data[a].name +"-"+data[a].unit_variable_value);
          (controls.at(k).get('demoArray') as FormArray).at(a).patchValue({
            product_variable_id:data[a].product_unit_variable_id,
            [data[a].name]:data[a].unit_variable_value,
            unit_variable_id:data[a].unit_variable_id
          });
          this.patchObserver.next(a+1)
        }
      })
      this.patchObserver.next(a)
    })
  }

  manageEditVariableControl(product,itemData){
    const control = (this.slipForm.get('categories') as FormGroup);
    product.setControl('demoArray', this.formBuilder.array([]));

    for(let k=0;k<itemData.unit_variables.length;k++){
      this.addEditItem(itemData.unit_variables[k].unit_variable,itemData.unit_variables[k].unit_variable_id,product,k)

      if(k == itemData.unit_variables.length - 1){
        this.addEditUnitToForm(product,itemData.unit,k+1)
        // console.log("productControl==",productControl)
      }
    }


  }

  addEditUnitToForm(product,item,k=0){
    product.get('demoArray').push(this.arrayGroup({[item]:new FormControl({value:0,disabled:true}, Validators.required)}))
    product.get('demoArray').controls[k].key = item
  }

  addEditItem(item,item_id,product,k) {
     // this.arrayItems.push(item);
     product.get('demoArray').push(
       this.arrayGroup({[item]:new FormControl(0, Validators.required),
       unit_variable_id:new FormControl(item_id, Validators.required)})
     )
     product.get('demoArray').controls[k].key = item
  }

  // private arrayEditGroup(data): FormGroup {
  //   return this.formBuilder.group(data);
  // }

  // patchItemValue(item_id,control,i){
  //   let a = (control.get("products") as FormArray);
  //    this.items.filter((item:any)=>{
  //     if(item.id == item_id){
  //       console.log(item.name)
  //       control.at(i).patchValue({item_name:item.name,gst:item.gst})
  //     }
  //   })
  // }

  ngOnDestroy(){
    // this.editSlipSubscriber.unsubscribe();
    this.refreshTagsSubscriber.unsubscribe()
  }

  get categories(): FormGroup {
    return this.formBuilder.group({
      category_id:"",
      category_name: "",
      products: this.formBuilder.array([this.products])
    });
  }

  get products(): FormGroup {
    return this.formBuilder.group({
      product_id:'',
      item_name: [null, Validators.required],
      item_code: [null],
      item: [null, Validators.required],
      description:[null],
      demoArray: this.formBuilder.array([]),
      qty:[null],
      rate:[null, Validators.compose([Validators.required, Validators.pattern(/^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/)])],
      amount: [{value:0,disabled:true}, Validators.required],
      unit_id:[null],
      unit:[null],
      discount:[null, Validators.compose([Validators.pattern(/^(100|[0-9]{1,2})?$/)])],
      gst:[null, Validators.compose([Validators.required,Validators.pattern(/^(100|[0-9]{1,2})?$/)])]
    });
  }



    checkSlipNo(value){
      // console.log("Slip no= : ",value);
      // return new Promise((resolve)=>{

      if(value.length > 0){
        let data={
          slip_number:value,
          business_id:this.loggedUserInfo.business_id
        }

        this.api.send("findDb",{
          table:"master_slips",
          conditions:[data]
        }).then((result:any)=>{
          // console.log("Invoice No==",result)
          if(result.data.length > 0){

            this.existingSlipStatus = true;
            // resolve(true)
          }else{
            this.existingSlipStatus = false;
            // resolve(false)
          }
        })
      }else{
        this.existingSlipStatus = false;
        // resolve(false)
      }
      // })

    }

  getLastSlipId(){
    this.api.send("findDb",{
      fields:["slip_number"],
      table:"master_slips",
      conditions:[{business_id:this.business_id}],
      order:"slip_number DESC",
      limit:1
    }).then((res:any)=>{

      if(res.data.length > 0){

        this.slipForm.patchValue({slip_number:parseInt(res.data[0].slip_number) + 1})
        this.observables.setSlipNumberStatus.next({slip_number:res.data[0].slip_number})
      }else{
        this.slipForm.patchValue({slip_number:1})

      }

    })
  }

  calculateTotal(i,j,category,product){

    const control1 = category.get("products");
    const control = this.slipForm.getRawValue()['categories'][j]['products'];

    let demoArrayControl = product.get('demoArray').controls;
    let result = []
    for(let k=0;k<demoArrayControl.length -1;k++){

      result.push(demoArrayControl[k].value[demoArrayControl[k].key])
    }

    // console.log("result=",result)
    let abc = result.reduce( ( accumulator, currentValue ) => {
      return accumulator*currentValue
    }, 1);

    let demoArrayLength = control[i].demoArray.length;
    // console.log("control=",control[0].demoArray[control[0].demoArray.length - 1])
    let unit_name = Object.keys(control[i].demoArray[demoArrayLength - 1])[0]
    // control.patchValue({[unit_name]:abc})
    // console.log("product.value.discount=",product.value.discount)
    let discount = product.value.rate/100*product.value.discount;
    // console.log("discount=",discount)
    let actualAmount:any = (abc*(product.value.rate - discount));
    // let actualAmount:any = (control[i].qty*control[i].rate);
    // console.log("product==",product)
    product.get('demoArray').controls[demoArrayLength-1].patchValue({[unit_name]:abc.toFixed(2)})
    product.patchValue({amount:actualAmount.toFixed(3)})
    //
    // console.log("arrayDemo=",product.get('demoArray').controls[demoArrayLength-1])
    this.calculateTotalAmount()
    this.calculateGSTTotalAmount()

  }

  calculateTotalAmount(){
    let total = 0;

    for(let i =0;i<this.slipForm.getRawValue()['categories'].length;i++){
      total = total + this.slipForm.getRawValue()['categories'][i]['products'].reduce( ( accumulator, currentValue ) => {
        return accumulator + parseFloat(currentValue.amount);
      }, 0);

      this.slipForm.patchValue({total_amount:total.toFixed(3)})
    }

  }
  calculateGSTTotalAmount(){
    let total = 0;

    for(let i =0;i<this.slipForm.getRawValue()['categories'].length;i++){
      total = total + this.slipForm.getRawValue()['categories'][i]['products'].reduce( ( accumulator, currentValue ) => {

        return accumulator + (currentValue.amount*currentValue.gst)/100;

      }, 0);

      this.slipForm.patchValue({gst_total_amount:total.toFixed(3)});

    }

  }

  getParty(){

   this.api.send("findDb",{
     table:"parties",
     conditions:[{business_id:this.business_id}],
     order:"id DESC"
   }).then((result:any)=>{
     // console.log("results=",result)
     this.parties = result.data;
     this.options = result.data;

     this.filteredOptions = this.slipForm.get('party_name').valueChanges
     .pipe(
       startWith(''),
       map(value => this._filter(value))
     );
   });

  }

  private _filter(value: any): string[] {
    if(value){

      const filterValue = value.toLowerCase();
      return this.options.filter(option => option.business_name.toLowerCase().includes(filterValue));
    }
  }


    onSelectionChanged(_event: any,userData) {

      if (_event.isUserInput) {
        // console.log("userData=",userData)
        this.slipForm.patchValue({party_id:userData.id,user_id:userData.user_id})
        this.party_gstin = userData.gstin;
      }

    }



    onSelectionChanged1(_event: any,itemData,i,category,j,product) {
      if(_event.isUserInput){

          if(product.value.item != itemData.id){

            const control = category.get("products");

            let a = (category.get("products") as FormArray);


            this.items.filter((item:any)=>{
              if(item.id == itemData.id){
                control.at(i).patchValue({item:item.id,item_code:item.item_code,unit_id:item.unit_id,unit:item.unit,gst:item.gst,rate:item.rate,qty:null,description:null,amount:0,discount:item.discount})
                if(itemData.unit_variables.length > 0){
                  if(product.value.product_id == ''){

                    this.manageVariableControl(product,itemData)
                  }else{
                    this.manageVariableControl(product,itemData,true)
                  }
                }else{
                  this.addUnitToForm(product,itemData.unit)
                }
              }
            })

            this.calculateTotalAmount()
            this.calculateGSTTotalAmount()
          }else{
            // console.log("same item selected=")
          }
      }
    }


    manageVariableControl(product,itemData,updateStatus=false){
      // const productControl = (product.get("demoArray") as FormArray);
      // const productControl = product.get("demoArray")
      if(updateStatus){

        // console.log("product ==",product)
        for(let i=0;i<product.value.demoArray.length;i++){

          // console.log("product id==",product.value.demoArray[i].product_variable_id)
          this.DeletedUnitVariableRows.push(product.value.demoArray[i].product_variable_id)
        }
      }

      const control = (this.slipForm.get('categories') as FormGroup);
      product.setControl('demoArray', this.formBuilder.array([]));

      for(let k=0;k<itemData.unit_variables.length;k++){
        this.addItem(itemData.unit_variables[k].unit_variable,itemData.unit_variables[k].unit_variable_id,product,k)

        if(k == itemData.unit_variables.length - 1){
          this.addUnitToForm(product,itemData.unit,k+1)
          // console.log("productControl==",productControl)
        }
      }


    }

    addUnitToForm(product,item,k=0){
      product.get('demoArray').push(this.arrayGroup({[item]:new FormControl({value:0,disabled:true}, Validators.required)}))
      product.get('demoArray').controls[k].key = item
    }

    addItem(item,item_id,product,k) {
       // this.arrayItems.push(item);
       product.get('demoArray').push(
         this.arrayGroup({
           product_variable_id:new FormControl(''),
           key:new FormControl(`${item}`),
           [item]:new FormControl(0, Validators.compose([Validators.required, Validators.pattern(/^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/)])),
           unit_variable_id:new FormControl(item_id, Validators.required)
         })
       )
       product.get('demoArray').controls[k].key = item
    }

    private arrayGroup(data): FormGroup {
      return this.formBuilder.group(data);
    }


    manageCategoryControl(i,category,j){
      this.itemOptions[j] = []
    }


     ManageNameControl(index: number,category,j) {
      // console.log("index=",index)

      const mainFormControl = (this.slipForm.get("categories") as FormArray);

       this.itemOptions[j][index]=(mainFormControl.at(j).get("products") as FormArray).at(index).get('item_name').valueChanges
      .pipe(
        startWith(''),
        map(value => this._filters(value))
      );
    }

    private _filters(value: any): string[] {
      if(value){

        const filterValue = value.toLowerCase();
        return this.items.filter(option => option.name.toLowerCase().includes(filterValue));
      }

    }

  getItem(){
    this.items= []
     this.api.send("findDb",{
       table:"items as I",
       fields:["U.name as unit","U.id as unit_id","UV.name as unit_variable","IU.unit_variable_id","I.*"],
       joins:[{
         type:'left',
         table:'item_unit_variables as IU',
         conditions:["IU.item_id = I.id"]
       },{
         type:'left',
         table:'unit_variables as UV',
         conditions:["UV.id = IU.unit_variable_id"]
       },{
         type:'left',
         table:'units as U',
         conditions:["U.id = I.unit_id"]
       }],
       conditions:[{"I.business_id":this.business_id}]
     }).then((result:any)=>{
       let group = _.groupBy(result.data,'id')
       let value = _.values(group);

       value.filter((item)=>{
        if(item.length > 1){
          let unit_variables=[]

          for(let i=0;i<item.length;i++){
            unit_variables.push({unit_variable:item[i].unit_variable,unit_variable_id:item[i].unit_variable_id})

            if(i == item.length -1){

              this.items.push({
                business_id: item[0].business_id,
                cess: item[0].cess,
                discount: item[0].discount,
                gst: item[0].gst,
                id: item[0].id,
                name: item[0].name,
                item_code:item[0].item_code,
                rate: item[0].rate,
                unit:item[0].unit,
                unit_id:item[0].unit_id,
                unit_variables: unit_variables,
                unit_variable_name:Array.prototype.map.call(unit_variables, s => s.unit_variable).toString()
                // unit_id:item[0].unit_id
              })
            }
          }
        }else{

          this.items.push({
            business_id: item[0].business_id,
            cess: item[0].cess,
            discount: item[0].discount,
            gst: item[0].gst,
            id: item[0].id,
            name: item[0].name,
            item_code:item[0].item_code,
            rate: item[0].rate,
            unit:item[0].unit,
            unit_id:item[0].unit_id,
            unit_variables: [{unit_variable:item[0].unit_variable,unit_variable_id:item[0].unit_variable_id}],
            unit_variable_name:item[0].unit_variable
          })
        }
     })

   })
  }
  getTags(){
   this.api.send("findDb",{
     table:"tags",
     conditions:[{business_id:this.business_id}]
   }).then((result:any)=>{
     this.tags=result.data
   })
  }

  addTags(){
      this.observables.tagPopupStatus.next()
  }


  addCategory(status = false) {
    return new Promise((resolve)=>{
      const control = (this.slipForm.get("categories") as FormArray);
      control.push(this.categories);
      this.manageCategoryControl(0,(control.at(control.controls.length-1) as FormGroup),control.controls.length-1)
      if(status){

        this.ManageNameControl(0,(control.at(control.controls.length-1) as FormGroup),control.controls.length-1)
      }

      resolve(true);
    })
  }

  removeCategory(item,categories,category,deleteID): void {

    // console.log("deleted category row id==",deleteID);
    if(confirm("Are you sure to remove Category and its Associate Products?")){

      if(deleteID != ''){
        this.DeletedCategoryRows.push(deleteID)
      }


      if(categories.value.length - 1 == item){
        (this.slipForm.get("categories") as FormArray).removeAt(item);
        this.manageCategoryControl(item-1,categories,item);
      }else{
        (this.slipForm.get("categories") as FormArray).removeAt(item);
        for(let i=item;i<(this.slipForm.get("categories") as FormArray).value.length;i++){

          for(let j=0;j<(this.slipForm.get("categories") as FormArray).value[i].products.length;j++){

            this.ManageNameControl(j,category,i)
          }
        }
      }


      this.calculateTotalAmount();
      this.calculateGSTTotalAmount();
    }
  }
  addProduct(category,j): void {

    category.get("products").push(this.products);
    this.ManageNameControl(category.value.products.length - 1,category,j);
  }

  removeProduct(item,category,categoryId,deleteID,j): void {
    if(confirm("Are you sure to remove this Product?")){

      if(deleteID != '' && categoryId != ''){
        this.DeletedProductRows.push({product_id:deleteID,category_id:categoryId})
      }
      if(category.value.products.length - 1 == item){
        category.get("products").removeAt(item);
        this.ManageNameControl(item-1,category,j);
      }else{
        category.get("products").removeAt(item);
        this.ManageNameControl(item,category,j);
      }


      this.calculateTotalAmount()
      this.calculateGSTTotalAmount()
    }
  }

  // checkUser() {
  //
  //     if (!this.selectedParty || this.selectedParty.full_name !== this.slipForm.get('party_name').value) {
  //       this.slipForm.get('party_name').setValue(null);
  //       this.selectedParty = null;
  //     }
  //   }

  submitData(formValue,formDirective:FormGroupDirective,printStatus){
    this.loadingStatus = true;
    let value = this.slipForm.getRawValue();
    // console.log("value=",value)
    // return
    this.productDetails = []
    let date:any = new Date(value.slip_date);
    let slip_date:any=this.datePipe.transform(date, 'yyyy-MM-dd'); //whatever format you need.

    this.api.send("insertDb",{
      table:"slips",
      data:{
        business_id:this.business_id,
        slip_number:value.slip_number,
        party_id:value.party_id,
        slip_date:slip_date,
        payment_status:value.payment_status,
        total_amount: value.total_amount,
        gst_total_amount:value.gst_total_amount,
        delivery_to: value.delivery_to,
        note:value.note,
        user_id:value.user_id
      }
    }).then((result:any)=>{
      if(result.data.affectedRows){
        this.addToMaster(value,slip_date,result.data.insertId).then((resp:any)=>{
          if(resp.status){
            this.productDetails.push({master_slip_id:resp.master_slip_id,categories:[]})
            this.saveCategory(value.categories,result.data.insertId).then((categoryRes:any)=>{

              if(categoryRes){
                // console.log("this.product details==",this.productDetails)
                if(value.tags){

                  this.saveTags(value.tags,result.data.insertId).then((tagRes:any)=>{
                    this.prepareMasterProductDetails().then((masterRes:any)=>{
                      // return
                      this.saveMasterProductDetails(masterRes).then((saveMasterRes:any)=>{

                        this.resetAll(formDirective,printStatus,resp.master_slip_id)
                      })
                    })
                  })
                }else{
                  this.prepareMasterProductDetails().then((masterRes:any)=>{
                    // return
                    this.saveMasterProductDetails(masterRes).then((saveMasterRes:any)=>{

                      this.resetAll(formDirective,printStatus,resp.master_slip_id)
                    })
                  })
                }

              }else{
                this.observables.showToastMessage({type:1,message:"Slip Can\'t Create, Try again..."})

              }

            })
          }else{
            this.observables.showToastMessage({type:1,message:"Slip Can\'t Create in Master, Try again..."})
          }
        })
      }
    })
  }

  addToMaster(value,slip_date,slip_id){
    let tags = []
    if(value.tags) {
      value.tags.filter(item=>{
        for(let i=0;i<this.tags.length;i++){
          if(item == this.tags[i].id){
            tags.push({tag_id:this.tags[i].id,tag:this.tags[i].tag_name})
            break;
          }
        }
      })
    }

    return new Promise((resolve)=>{
      this.api.send("insertDb",{
        table:"master_slips",
        data:{
          business_id:this.business_id,
          slip_id:slip_id,
          slip_number:value.slip_number,
          party_id:value.party_id,
          party_name:value.party_name,
          gstin:this.party_gstin,
          slip_date:slip_date,
          user_name:this.loggedUserInfo.username,
          total_amount: value.total_amount,
          gst_total_amount:value.gst_total_amount,
          delivery_to: value.delivery_to,
          note:value.note,
          user_id:value.user_id,
          tags:(tags.length)?JSON.stringify(tags):null
        }
      }).then((result:any)=>{
        // console.log("master result=",result)
        if(result.data.affectedRows){
          resolve({status:true,master_slip_id:result.data.insertId});
        }else{
          resolve({status:false});

        }
      })
    })
  }

  saveMasterProductDetails(data){
    // console.log("master Data prepared=",data)
    return new Promise((resolve)=>{

      let k=0;

      this.masterSlipProductsIterateSubscriber = this.masterSlipProductsIterationObserver.subscribe((k)=>{
        if(k>=data.length){
          this.masterSlipProductsIterateSubscriber.unsubscribe()
          resolve(true);
        }else{
          this.api.send("insertDb",{
            table:"master_slip_products",
            data:data[k]
          }).then((result:any)=>{
            // console.log("master product details result=",result)
            if(result.data.affectedRows){

              this.masterSlipProductsIterationObserver.next(k+1);
            }else{
              this.masterSlipProductsIterationObserver.next(k+1);

            }
          })

        }
      })

      this.masterSlipProductsIterationObserver.next(k)

    })
  }
  prepareMasterProductDetails(){
    // console.log("preparing=",this.productDetails)
    // return;
    return new Promise((resolve)=>{
      let k=0;
      let data = []
      this.masterCategoryIterateSubscriber = this.masterCategoryIterationObserver.subscribe((k)=>{
        if(k>=this.productDetails[0].categories.length){
          this.masterCategoryIterateSubscriber.unsubscribe()
          // console.log("datat=====",data)
          resolve(data)
        }else{
          this.productDetails[0].categories[k].master_slip_id = this.productDetails[0].master_slip_id;

          this.getProductDetails(this.productDetails[0].categories[k].products).then((res:any)=>{
            delete this.productDetails[0].categories[k].products
            // console.log("ccc=",this.productDetails[0].categories[k])
            // console.log("rrr=",res)
            // for(let i=0;i<res.length;i++){
            //   data.push(this.prepareObject([this.productDetails[0].categories[k],res[i]]))
            //   if(i == res.length - 1){
            //
            //
            //   }
            // }

            let i = 0
            this.prepareProductsIterateSubscriber = this.prepareProductsIterationObserver.subscribe((i)=>{
              if(i >= res.length){
                this.prepareProductsIterateSubscriber.unsubscribe()
                this.masterCategoryIterationObserver.next(k+1);
              }else{
                data.push(this.prepareObject([this.productDetails[0].categories[k],res[i]]))
                this.prepareProductsIterationObserver.next(i+1)
              }
            })

            this.prepareProductsIterationObserver.next(i)
            // console.log("saddsad=",this.prepareObject([this.productDetails[0].categories[k],res[0]]))
            // data.push(this.prepareObject([this.productDetails[0].categories[k],res[0]]))
          })
        }
      })

      this.masterCategoryIterationObserver.next(k)

    })
  }


  getProductDetails(products){

    return new Promise((resolve)=>{
      let k=0;
      let productArr = []
      this.masterProductIterateSubscriber = this.masterProductIterationObserver.subscribe((k)=>{
        if(k>=products.length){
          this.masterProductIterateSubscriber.unsubscribe()
          resolve(productArr)
        }else{

          this.getVariableDetails(products[k].variables).then((res3:any)=>{
            delete products[k].variables;
            productArr.push(this.prepareObject([products[k],res3]))
            this.masterProductIterationObserver.next(k+1);
          })
        }
      })

      this.masterProductIterationObserver.next(k)
    })

  }

  prepareObject(arr){
    return arr.reduce(function(result, currentObject) {
        for(var key in currentObject) {
            if (currentObject.hasOwnProperty(key)) {
                result[key] = currentObject[key];
            }
        }
        return result;
    }, {});
  }

  getVariableDetails(variables){
    // console.log("variables===",variables)
    return new Promise((resolve)=>{
      let k=0;
      let unit_variables = []
      this.masterVariablesIterateSubscriber = this.masterVariablesIterationObserver.subscribe((k)=>{
        if(k>=variables.length){
          this.masterVariablesIterateSubscriber.unsubscribe()
          resolve(this.prepareObject(unit_variables))
        }else{
          unit_variables.push(variables[k])
          this.masterVariablesIterationObserver.next(k+1);

        }
      })

      this.masterVariablesIterationObserver.next(k)
    })
  }

  saveTags(tags,slip_id){
    return new Promise((resolve)=>{
      let k= 0;
      this.tagIterateSubscriber = this.tagIterationObserver.subscribe((k)=>{
        if(k >= tags.length){
          this.tagIterateSubscriber.unsubscribe()
          resolve(true)
        }else{
          this.api.send("insertDb",{
            table:'slip_invoice_tags',
            data:{
              business_id:this.loggedUserInfo.business_id,
              slip_id:slip_id,
              tag_id:tags[k]
            }
          }).then((res:any)=>{

            this.tagIterationObserver.next(k+1);
          })
        }
      })
      this.tagIterationObserver.next(k)
    })
  }

  removeTags(tags,slip_id){
    return new Promise((resolve)=>{
      let k= 0;
      this.tagIterateSubscriber = this.tagIterationObserver.subscribe((k)=>{
        if(k >= tags.length){
          this.tagIterateSubscriber.unsubscribe()
          resolve(true)
        }else{
          this.api.send("deleteDb",{
            table:'slip_invoice_tags',
            conditions:[{slip_id:slip_id,tag_id:tags[k]}]
          }).then((res:any)=>{

            this.tagIterationObserver.next(k+1);
          })
        }
      })
      this.tagIterationObserver.next(k)
    })
  }

  cancelUpdate(){

    this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/dashboard')])
  }



  updateSlip(formValue,formDirective:FormGroupDirective){
    if(confirm("Are you sure to update new changes in Slip?")){
      let value = this.slipForm.getRawValue();

      // console.log("slip edtiting value==",value)

      let date:any = new Date(value.slip_date);
      let slip_date:any=this.datePipe.transform(date, 'yyyy-MM-dd'); //whatever format you need.

      this.api.send("updateDb",{
        table:"slips",
        data:{
          slip_number:value.slip_number,
          party_id:value.party_id,
          slip_date:slip_date,
          payment_status:value.payment_status,
          total_amount:value.total_amount,
          gst_total_amount:value.gst_total_amount,
          delivery_to:value.delivery_to,
          user_id:value.user_id,
          note:value.note
        },
        conditions:[{id:this.editSlipId}]
      }).then((result:any)=>{
        if(result.data.affectedRows){
          this.editCategory(value.categories).then((categoryRes:any)=>{
            if(categoryRes){
              if(value.tags){
                if(this.editTags.length > 0){
                  let intersectionArr = _.intersection(value.tags,this.editTags);
                  // console.log("intersection=",_.intersection(value.tags,this.editTags));
                  let differenceArr1 = _.difference(value.tags,intersectionArr)
                  // console.log("differenceArr1==",differenceArr1)
                  let differenceArr2 = _.difference(this.editTags,intersectionArr)
                  // console.log("differenceArr2==",differenceArr2)
                  if(differenceArr1.length > 0 && differenceArr2.length > 0){
                    //add from diff1 and remove from diff2
                    this.saveTags(differenceArr1,this.editSlipId).then((res:any)=>{
                      this.removeTags(differenceArr2,this.editSlipId).then((res1:any)=>{
                        this.resetAll(formDirective)
                      })
                    })
                  }else if(differenceArr1.length == 0 && differenceArr2.length == 0){
                    //tags not updated same as before
                    this.resetAll(formDirective)
                  }else if(differenceArr1.length > 0 && differenceArr2.length == 0){
                    //add from diff1
                    this.saveTags(differenceArr1,this.editSlipId).then((res:any)=>{
                      this.resetAll(formDirective)
                    })
                  }else if(differenceArr1.length == 0 && differenceArr2.length > 0){
                    //remove from diff2
                    this.removeTags(differenceArr2,this.editSlipId).then((res1:any)=>{
                      this.resetAll(formDirective)
                    })
                  }
                }else{
                  //update all
                  this.saveTags(value.tags,this.editSlipId).then((res:any)=>{
                    this.resetAll(formDirective)
                  })
                }
              }else{
                if(this.editTags.length > 0){
                  //remove all tags
                  this.removeTags(this.editTags,this.editSlipId).then((res1:any)=>{
                    this.resetAll(formDirective)
                  })
                }else{
                  this.resetAll(formDirective)
                }
              }


            }else{
              this.observables.showToastMessage({type:1,message:'Slip Not Updated, Try again...'});
            }

          })
        }
      })
    }
  }

  resetAll(formDirective,printStatus=false,slip_id=null){
    formDirective.resetForm();
    this.slipForm.reset();
    const control = (this.slipForm.get('categories') as FormGroup);
    control.setControl('products', this.formBuilder.array([]));
    this.slipForm.setControl('categories', this.formBuilder.array([]));


    this.addCategory(true);
    // .then(()=>{
    //
    //   this.addProduct(((this.slipForm.get("categories") as FormArray).at(0) as FormGroup),0);
    // })

    if(this.editStatus){
      this.editStatus = false;
      this.editOnceStatus = false;
      this.observables.showToastMessage({type:0,message:'Slip Updated...'});
      this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/dashboard')])
    }else{

      this.slipForm.patchValue({slip_date:moment()})

      this.editStatus = false;
      this.editOnceStatus = false;
      if(printStatus){

        // this.observables.showSlipViewStatus.next({id:result.data.insertId,invoiceStatus:true,invoiceSlipStatus:true})
        this.observables.showSlipViewStatus.next({id:slip_id,invoiceStatus:true,invoiceSlipStatus:true})
      }

      this.getLastSlipId()
      this.loadingStatus = false;
      this.observables.showToastMessage({type:0,message:"Slip Created Successfully."})
    }
  }

  getnum(value){
    return parseFloat(value)
  }

  saveCategory(categories,slipId){
    return new Promise((resolve)=>{
      let k = 0;
      this.iterateSubscriber = this.iterationObserver.subscribe((k)=>{
        if(k>=categories.length){
            this.iterateSubscriber.unsubscribe();
            resolve(true);
         }else{

           this.api.send("insertDb",{
             table:"categories",
             data:{
               category_name:categories[k].category_name,
               slip_id:slipId
             }
           }).then((categoryRes:any)=>{
             if(categoryRes.data.affectedRows){
               this.productDetails[0].categories.push({category_name:categories[k].category_name,category_id:categoryRes.data.insertId,products:[]})

               this.saveProducts(categories[k].products,slipId,categoryRes.data.insertId,this.productDetails[0].categories[k]).then((productRes:any)=>{
                  // this.productDetails[0].categories[k].products.push(productRes.products)
                  this.iterationObserver.next(k+1);

               })

             }else{

               resolve(false)
             }
           })
         }
      })

      this.iterationObserver.next(k);
    })
  }
  editCategory(categories){
    return new Promise((resolve)=>{
      let k = 0;
      this.updateCategoryIterateSubscriber = this.updateCategoryIterationObserver.subscribe((k)=>{
        if(k>=categories.length){
            this.updateCategoryIterateSubscriber.unsubscribe();
            if(this.DeletedCategoryRows.length > 0){
              this.deleteCategory(this.DeletedCategoryRows).then((deleteCategoryres:any)=>{
                resolve(true);
              })

            }else{
              resolve(true);
            }
         }else{

           if(categories[k].category_id == ''){
              this.api.send("insertDb",{
                table:"categories",
                data:{
                  category_name:categories[k].category_name,
                  slip_id:this.editSlipId
                }
              }).then((categoryRes:any)=>{
                if(categoryRes.data.affectedRows){

                  this.saveProducts(categories[k].products,this.editSlipId,categoryRes.data.insertId).then((productRes:any)=>{

                     this.updateCategoryIterationObserver.next(k+1);

                  })

                }else{

                  resolve(false)
                }

              })

           }else{

             this.api.send("updateDb",{
               table:"categories",
               data:{
                 category_name:categories[k].category_name
               },
               conditions:[{
                 id:categories[k].category_id,
                 slip_id:this.editSlipId
               }]
             }).then((categoryRes:any)=>{
               if(categoryRes.data.affectedRows){
                 this.updateProducts(categories[k].products,categories[k].category_id).then((productRes:any)=>{

                    this.updateCategoryIterationObserver.next(k+1);

                 })

               }else{

                 resolve(false)
               }
             })
           }
         }
       })
      this.updateCategoryIterationObserver.next(k);
    })
  }
  deleteCategory(deletingCategories){
    return new Promise((resolve)=>{
      let k = 0;
      this.deleteCategoryIterateSubscriber = this.deleteCategoryIterationObserver.subscribe((k)=>{
        if(k>=deletingCategories.length){
          this.deleteCategoryIterateSubscriber.unsubscribe();
            resolve(true);
         }else{
           this.api.send("deleteDb",{
             table:"categories",
             conditions:[{
               id:deletingCategories[k],
               slip_id:this.editSlipId
             }]
           }).then((delRes:any)=>{
             if(delRes.data.affectedRows){
               this.api.send("deleteDb",{
                 table:"product_details",
                 conditions:[{
                   category_id:deletingCategories[k]
                 }]
               }).then((delResult:any)=>{
                 this.api.send("deleteDb",{
                   table:"product_unit_variables",
                   conditions:[{
                     category_id:deletingCategories[k]
                   }]
                 }).then((delVariable:any)=>{

                   this.deleteCategoryIterationObserver.next(k+1);
                 })
               })
             }else{

               resolve(false)
             }
           })
         }
      })

      this.deleteCategoryIterationObserver.next(k);
    })
  }
  deleteProducts(deletingProducts){
    return new Promise((resolve)=>{
      let k = 0;
      this.deleteProductIterateSubscriber = this.deleteProductIterationObserver.subscribe((k)=>{
        if(k>=deletingProducts.length){
          this.deleteProductIterateSubscriber.unsubscribe()
            resolve(true);
         }else{

           this.api.send("findDb",{
             table:"categories",
             conditions:[{id:deletingProducts[k].category_id}]
           }).then((delRes:any)=>{
             if(delRes.data.length > 0){
               this.api.send("deleteDb",{
                 table:"product_details",
                 conditions:[{
                   category_id:deletingProducts[k].category_id,
                   id:deletingProducts[k].product_id
                 }]
               }).then((delResult:any)=>{
                 this.api.send("deleteDb",{
                   table:"product_unit_variables",
                   conditions:[{
                     product_detail_id:deletingProducts[k].product_id
                   }]
                 }).then((variableDelRes:any)=>{

                   this.deleteProductIterationObserver.next(k+1);
                 })
               })
             }else{

               this.deleteProductIterationObserver.next(k+1);
             }
           })
         }
      })

      this.deleteProductIterationObserver.next(k);
    })
  }


  saveProducts(products,slipId,categoryId,category=null){
    // console.log("category in save product =",category)

    return new Promise((resolve)=>{
      let a = 0

      this.productSubscriber = this.productObserver.subscribe((a)=>{
        if(a>=products.length){
          this.productSubscriber.unsubscribe();
          resolve({status:true,products:category.products})
        }else{

          let gst_amount = parseFloat(products[a].amount)/100*products[a].gst;


             this.api.send("insertDb",{
               table:"product_details",
               data:{
                 slip_id:slipId,
                 category_id:categoryId,
                 item_id:products[a].item,
                 description:products[a].description,
                 qty:products[a].qty,
                 rate:products[a].rate,
                 discount:products[a].discount,
                 amount:products[a].amount
               }
             }).then((result2:any)=>{
               if(result2.data.affectedRows){
                 category.products.push({
                   product_detail_id:result2.data.insertId,
                   item_id:products[a].item,
                   item_name:products[a].item_name,
                   item_code:products[a].item_code,
                   gst:products[a].gst,
                   cess:0,
                   item_description:products[a].description,
                   rate:products[a].rate,
                   unit:products[a].unit,
                   discount:products[a].discount,
                   gross_amount:parseFloat(products[a].amount),
                   sgst:(this.loggedUserInfo.gstin.substring(0,2) == this.party_gstin.substring(0,2))?gst_amount/2:0,
                   cgst:(this.loggedUserInfo.gstin.substring(0,2) == this.party_gstin.substring(0,2))?gst_amount/2:0,
                   igst:(this.loggedUserInfo.gstin.substring(0,2) != this.party_gstin.substring(0,2))?gst_amount:0,
                   net_amount:parseFloat(products[a].amount) + gst_amount,
                   variables:[]
                 })

                 if(products[a].demoArray.length > 1){
                   this.setArrayForUnitVariable(products[a].demoArray,result2.data.insertId,categoryId,false,category.products[a]).then((arrayRes:any)=>{
                     category.products[a].variables = arrayRes.variables
                     this.productObserver.next(a+1);
                   })
                 }else{
                   this.productObserver.next(a+1);
                 }

               }else{

                 resolve(false);
               }

             })

          }

        })

      this.productObserver.next(a);
    })
  }

  setArrayForUnitVariable(unitVariableArray,productId, categoryId,updateStatus=false,products=null){
    return new Promise((resolve,reject)=>{
      // this.arrayUnitVariableIterateSubscriber

      let a = 0
      this.arrayUnitVariableIterateSubscriber = this.arrayUnitVariableIterationObserver.subscribe((a)=>{
        if(a>=unitVariableArray.length-1){
          this.arrayUnitVariableIterateSubscriber.unsubscribe();
          if(this.DeletedUnitVariableRows.length > 0 && updateStatus){

            this.deleteUnitVariables(this.DeletedUnitVariableRows).then((delRes:any)=>{

              resolve({status:true,variables_status:false})
            })
          }else{
            if(products){

              resolve({status:true,variables_status:true,variables:products.variables})
            }else{

              resolve({status:true,variables_status:false})
            }
          }
        }else{
          // products.variables.push({['col_'+(a+1)]:unitVariableArray[a].key,['col_'+(a+1)+'_value']:unitVariableArray[a][unitVariableArray[a].key]})
          // products.unit_value = unitVariableArray[unitVariableArray.length - 1][products.unit]
          // console.log("unitVariableArray[a]==",unitVariableArray[a])
          let data={};
          // let kyz = Object.keys(unitVariableArray[a])[0];
          // console.log("kyz==",kyz)
          data["category_id"] = categoryId;
          data["product_detail_id"] = productId;
          // data["master_slip_product_id"] = productId;
          data["unit_variable_id"]=unitVariableArray[a].unit_variable_id;
          data["unit_variable_value"]=unitVariableArray[a][unitVariableArray[a].key];

          if(unitVariableArray[a].product_variable_id == ''){
            // if(updateStatus){

              //old new insert
              this.saveUnitVariables(data).then((variableRes:any)=>{

                products.variables.push({product_variable_id:variableRes,['col_'+(a+1)]:unitVariableArray[a].key,['col_'+(a+1)+'_value']:unitVariableArray[a][unitVariableArray[a].key]})
                products.unit_value = unitVariableArray[unitVariableArray.length - 1][products.unit]
                this.arrayUnitVariableIterationObserver.next(a+1);

              })
            // }else{
            //
            //   //new insert
            // }
          }else{

            //update
            this.updateUnitVariable(data,unitVariableArray[a].product_variable_id).then((variableRes:any)=>{


              this.arrayUnitVariableIterationObserver.next(a+1);

            })
          }

        }

      })

      this.arrayUnitVariableIterationObserver.next(a);
    })
  }

  updateUnitVariable(data,product_variable_id){
    return new Promise((resolve)=>{

      this.api.send("updateDb",{
        table:"product_unit_variables",
        data:data,
        conditions:[{id:product_variable_id}]
      }).then((result2:any)=>{
        if(result2.data.affectedRows){
          resolve(true)
        }
      })
    })
  }
  deleteUnitVariables(data){
    return new Promise((resolve)=>{
      let a = 0;
      this.deleteUnitVariableIterateSubscriber = this.deleteUnitVariableIterationObserver.subscribe((a)=>{
        if(a >= data.length){
          this.deleteUnitVariableIterateSubscriber.unsubscribe()
          resolve(true)
        }else{
          this.api.send("deleteDb",{
            table:"product_unit_variables",
            conditions:[{id:data[a]}]
          }).then((result2:any)=>{
              this.deleteUnitVariableIterationObserver.next(a+1);
          })
        }
      })
      this.deleteUnitVariableIterationObserver.next(a)

    })
  }

  saveUnitVariables(data){
    // console.log("unitVariables data=",data)
    return new Promise((resolve)=>{
      this.api.send("insertDb",{
        table:"product_unit_variables",
        data:data
      }).then((result2:any)=>{
        if(result2.data.affectedRows){

          resolve(result2.data.insertId)
        }
      })
    })
  }

  updateProducts(products,categoryId){
    // console.log("products in update ==",products)

    return new Promise((resolve)=>{
      let a = 0
      this.updateProductIterateSubscriber = this.updateProductIterationObserver.subscribe((a)=>{
        if(a>=products.length){
          this.updateProductIterateSubscriber.unsubscribe();
          if(this.DeletedProductRows.length > 0){

            this.deleteProducts(this.DeletedProductRows).then((deleteProductRes:any)=>{

              resolve(true)
            })
          }else{

            resolve(true)
          }
        }else{
          if(products[a].product_id == ''){

           this.api.send("insertDb",{
             table:"product_details",
             data:{
               slip_id:this.editSlipId,
               category_id:categoryId,
               item_id:products[a].item,
               description:products[a].description,
               qty:products[a].qty,
               rate:products[a].rate,
               discount:products[a].discount,
               amount:products[a].amount
             }
           }).then((result2:any)=>{
             if(result2.data.affectedRows){
               if(products[a].demoArray.length > 1){
                 this.setArrayForUnitVariable(products[a].demoArray,result2.data.insertId,categoryId).then((arrayRes:any)=>{

                   this.updateProductIterationObserver.next(a+1);
                 })
               }else{
                 this.updateProductIterationObserver.next(a+1);
               }

             }else{

               resolve(false);
             }
           })
          }else{

            this.api.send("updateDb",{
              table:"product_details",
              data:{
                category_id:categoryId,
                item_id:products[a].item,
                description:products[a].description,
                qty:products[a].qty,
                rate:products[a].rate,
                discount:products[a].discount,
                amount:products[a].amount
              },
              conditions:[{
                id:products[a].product_id,slip_id:this.editSlipId
              }]
            }).then((result2:any)=>{
              if(result2.data.affectedRows){
                if(products[a].demoArray.length > 1){
                  this.setArrayForUnitVariable(products[a].demoArray,products[a].product_id,categoryId,true).then((arrayRes:any)=>{

                    this.updateProductIterationObserver.next(a+1);
                  })
                }else{
                  this.updateProductIterationObserver.next(a+1);
                }
                // this.updateProductIterationObserver.next(a+1);

              }else{

                resolve(false);
              }

            })
          }

        }

      })

      this.updateProductIterationObserver.next(a);
    })
  }
  }
